<template>
    <div>
        <template v-if="userPermissions.indexOf('access_social_media_calendar') > -1" class="container-fluid xyz">
            <section class="internal-page-banner-main col-12">
                <div class="container">
                    <div class="row">
                        <div class="page-title">
                            <h1> Social Media Calendar </h1>
                        </div>
                    </div>
                </div>
            </section>
            <!--End internal page banner section-->
            <div class="internal-page-main-section contact-page-main col-12 social-media-calendar-container">
                <!--bottom-contact-detail-->
                <div class="container">
                    <div v-show="swipViews == 2">
                        <div class="social-media-calendar bottom-employee-detail col-12 float-l">
                            <div class="">
                                <h2 class="color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full"> {{formTitle}} <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="buttonBack(2)">Back</button></h2>
                                <div class="">
                                    <form id="socialMediaForm">
                                        <!--Title-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="title">Title<span class="text-danger">*</span></label>
                                                <input v-model="title" type="text" class="form-control" id="title" placeholder="Title">
                                                <font class="text-danger">{{titleError}}</font>
                                            </div>
                                        </div>
                                        <!--Description-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="description">Description<span class="text-danger">*</span></label>
                                                <!--tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="description" v-model="description" class= "" ref="tm" ></tinymce-->
                                                <textarea id="description" @keyup='charCount()' :maxlength="charLimit" v-model="description" class="form-control" placeholder="Description"></textarea>
                                                <font class="text-danger">{{descriptionError}}</font>
                                            </div>
                                        </div>
                                        <!--Hash Tags :maxlength="charLimit" -->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="hashTag">Hash Tags</label>
                                                <textarea v-model="hashTag" @keyup='charCount()' class="form-control" id="hashTag" placeholder="Hash Tags"></textarea>
                                            </div>
                                        </div>
                                        <div class="float-r">
                                            <font class="text-danger">{{charCountError}}</font>
                                        </div>
                                        <div class="float-l">
                                            <font class="text-danger">{{charLimitError}}</font>
                                        </div>
                                        <!--Attachments-->
                                        <!-- Video file is allowed as 1st file only -->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="dropzone">Attachments</label>
                                                <vue-dropzone
                                                    ref="dropzone"
                                                    id="dropzone"
                                                    :options="dropzoneOptions"
                                                    @vdropzone-success = "uploadDocument"
                                                    @vdropzone-processing="disableButtons"
                                                    @vdropzone-processing-multiple="disableButtons"
                                                    @vdropzone-removed-file="removedSelectedFile"
                                                    @vdropzone-error="fileError"
                                                    @vdropzone-file-added="fileAdd"
                                                    @vdropzone-queue-complete="fileUploadProcessDone"
                                                    :useCustomSlot=true
                                                    >
                                                    <!-- removed below files added as it calles 2 times -->
                                                    <!-- @vdropzone-files-added="fileAdd" -->
                                                    <div class="dropzone-custom-content">
                                                        <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                                        <div class="subtitle">(Select files from your computer.)</div>
                                                    </div>
                                                </vue-dropzone>
                                            </div>
                                        </div>
                                        <div class="float-r">
                                            <font class="text-danger">{{filesCountError}}</font>
                                        </div>
                                        <div class="clearfix"></div>
                                        <!--Company & Social Media-->
                                        <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="hashTag">Company & Social Media</label>
                                                <multiselect
                                                    v-model="companySocialMedia"
                                                    name="listActivity"
                                                    id="listActivity"
                                                    label="name"
                                                    :options="companySocialMediaArr"
                                                    :multiple=true
                                                    track-by="id"
                                                    @input="changedValueSocialMedia()"
                                                    :hideSelected=false
                                                    :groupSelect=true
                                                    group-label="name"
                                                    group-values="social_media"
                                                    placeholder="Select Social Media">
                                                </multiselect>
                                                <font class="text-danger">{{companyError}}</font>
                                            </div>
                                        </div> -->


                                        <!--Date-->
                                        <div class="StartDate col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="startDate" slot="before">Post Date<span class="text-danger">*</span></label>
                                                <datePicker id="StartDate" v-model="startDateForm" :config="optionsStart"
                                                @dp-change="changeStartDt()"></datePicker>
                                                <font class="text-danger">{{startDateError}}</font>
                                            </div>
                                        </div>
                                        <!--TIME-->
                                        <div class="StartDate col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="StartTime" slot="before">Post Time</label>
                                                <datePicker id="StartTime" v-model="startTimeForm" :config="optionsTime"
                                                @dp-change="changeTimeDt()"></datePicker>
                                                <font class="text-danger">{{StartTimeError}}</font>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <!--Contact Person-->
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="userId">Contact Person<span class="text-danger">*</span></label>
                                                <input v-model="userId" type="text" class="form-control" id="userId" placeholder="Contact Person">
                                                <font class="text-danger">{{contactPersonError}}</font>
                                            </div>
                                        </div>
                                        <!--Contact Email-->
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="contactEmail">Contact Email<span class="text-danger">*</span></label>
                                                <input v-model="contactEmail" type="text" class="form-control" id="contactEmail" placeholder="Contact Email">
                                                <font class="text-danger">{{contactEmailError}}</font>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <!--Conatct Number-->
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="contactNumber">Contact Number</label>
                                                <input v-model="contactNumber" type="text" class="form-control" id="contactNumber" placeholder="Contact Number">
                                                <font class="text-danger">{{contactNumberError}}</font>
                                            </div>
                                        </div>
                                        <div v-if="editEventID != 0" class="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="createdByUserName">Created By</label>
                                                <span class="form-control" id="createdByUserName">{{createdByUserName}}</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="createdBy">{{createdByTitle}}</label>
                                                <span class="form-control" id="createdBy">{{createdBy}}</span>
                                            </div>
                                        </div>

                                        <template v-if="editEventID != 0 && is_approved != 2">
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                                <div class="form-group">
                                                    <template v-if="is_approved == 1">
                                                        <label for="approvedByUserName">Approved By</label>
                                                    </template>
                                                    <template v-else>
                                                        <label for="approvedByUserName">Denied By</label>
                                                    </template>
                                                    <span class="form-control" id="approvedByUserName">{{approvedByUserName}}</span>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                                <div class="form-group">
                                                    <template v-if="is_approved == 1">
                                                        <label for="approvedByTime">Approved At</label>
                                                    </template>
                                                    <template v-else>
                                                        <label for="approvedByTime">Denied At</label>
                                                    </template>
                                                    <span class="form-control" id="approvedByTime">{{approvedByTime}}</span>
                                                </div>
                                            </div>
                                        </template>

                                        <div class="clearfix"></div>
                                        <!--Error Alert-->
                                        <div class="row clearfix" >
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <div class="alert alert-danger" id="alertError">
                                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                                    <strong id="errorMsg" class="error"></strong>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <!--Buttons-->
                                        <div class="row clearfix"></div>
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="button-demo">
                                                <input id="CancelSocialMedia" type="submit" value="Cancel" class="btn btn-primary pull-right" v-on:click.prevent="buttonBack(2)">
                                                <input id="addSocialMediaBtn" type="submit" value="Save" class="mr-1 btn btn-primary pull-right" v-on:click.prevent="addEvent('post')">
                                                <!-- // remove permission for save // v-show="roleId <= 1 || userPermissions.indexOf('post_social_media') > -1" -->
                                                <!-- <input v-show="roleId <= 1 || userPermissions.indexOf('post_social_media') > -1 || userPermissions.indexOf('draft_social_media') > -1" id="draftSocialMediaBtn" type="submit" value="Draft" class="mr-1 btn btn-primary pull-right" v-on:click.prevent="addEvent('draft')">
                                                <input v-show="roleId <= 1 || userPermissions.indexOf('post_social_media') > -1" id="publishNowSocialMediaBtn" type="submit" value="Publish Now" class="mr-1 btn btn-primary pull-right" v-on:click.prevent="addEvent('publish_now')"> -->

                                                <template v-if="userPermissions.indexOf('manage_social_media_calendar_events') > -1">
                                                    <button v-if="selected.is_approved == 1 || selected.is_approved == 2" type="button" id="deniedEvent" class="btn btn-primary pull-right mr-1" v-on:click.prevent="checkEventForApproval(editEventID, 'deny')"><i class="fa fa-times" aria-hidden="true"></i> DENY</button>
                                                    <button v-if="selected.is_approved == 0 || selected.is_approved == 2" type="button" id="approvedEvent" class="btn btn-primary pull-right mr-1" v-on:click.prevent="checkEventForApproval(editEventID, 'approve')"><i class="fa fa-check" aria-hidden="true"></i> APPROVE</button>
                                                </template>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="swipViews == 1">
                        <div class="social-media-calendar bottom-employee-detail col-12 float-l">
                            <div class="">
                                <h2 class="color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full textOverFlow"> {{selected.title}}
                                    <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="buttonBack(0)"><i aria-hidden="true" class="fa fa-chevron-left"></i></button>
                                    <!--<template v-if="loginUserID == selected.created_by_id">-->
                                    <button v-show="roleId <= 1 || userPermissions.indexOf('post_social_media') > -1 || userPermissions.indexOf('draft_social_media') > -1" type="submit" class="mr-1 btn btn-primary pull-right" v-on:click.prevent="editEvent(selected.id, false)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                    <button v-show="roleId <= 1 || userPermissions.indexOf('post_social_media') > -1 || userPermissions.indexOf('draft_social_media') > -1" type="submit" class="mr-1 btn btn-primary pull-right" v-on:click.prevent="deleteEvents(selected.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                    <button v-show="roleId <= 1 || userPermissions.indexOf('post_social_media') > -1 || userPermissions.indexOf('draft_social_media') > -1" type="submit" class="mr-1 btn btn-primary pull-right" v-on:click.prevent="editEvent(selected.id, true)"><i class="fa fa-retweet" aria-hidden="true"></i></button>
                                    <!--</template>-->

                                    <template v-if="userPermissions.indexOf('manage_social_media_calendar_events') > -1">
                                        <button v-if="selected.is_approved == 1 || selected.is_approved == 2" type="button" id="deniedEvent" class="btn btn-primary pull-right mr-1" v-on:click.prevent="checkEventForApproval(selected.id, 'deny')"><i class="fa fa-times" aria-hidden="true"></i> DENY</button>
                                        <button v-if="selected.is_approved == 0 || selected.is_approved == 2" type="button" id="approvedEvent" class="btn btn-primary pull-right mr-1" v-on:click.prevent="checkEventForApproval(selected.id, 'approve')"><i class="fa fa-check" aria-hidden="true"></i> APPROVE</button>
                                    </template>
                                </h2>
                                <div class="">
                                    <div class=" bottom-employee-detail-left col-12 col-sm-6 col-md-6 col-lg-6">
                                        <div class="bg-color-table mt-20 float-l width-full">
                                            <div class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Contact Person </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.contact_person}} </p>
                                                </div>
                                            </div>
                                            <div class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Contact Email </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.contact_email}} </p>
                                                </div>


                                                <!-- <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Social Media </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <template v-for="(text, index) in selected.social_media">
                                                        <p class="color-blue heading-text-14 line-height-18"> {{ text.name }} </p>
                                                        <template v-if="(selected.social_media.length != 1)">
                                                            <br>
                                                        </template>
                                                    </template>
                                                </div> -->



                                            </div>
                                            <template v-if="selected.contact_number != ''">
                                                <div class="bus-detail-row width-full float-l">
                                                    <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                        <p class="small-bullet center"></p>
                                                    </div>
                                                    <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                        <p class="color-333333 heading-text-14 line-height-18"> Contact Number </p>
                                                    </div>
                                                    <div class="col-inner-detail col-number colpie-60 float-l">
                                                        <p class="color-blue heading-text-14 line-height-18"> {{selected.contact_number}} </p>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>

                                    </div>
                                    <div class="bottom-employee-detail-right col-12 col-sm-6 col-md-6 col-lg-6">
                                        <div class="bg-color-table mt-20 float-l width-full">
                                            <div class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Date </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.display_date}} </p>
                                                </div>
                                            </div>
                                            <!-- <div class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Companies To Share With </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.company_name}} </p>
                                                </div>
                                            </div> -->
                                            <div class="bus-detail-row width-full float-l ">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Hash Tags </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18 textOverFlow"> {{selected.has_tags}} </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" bottom-employee-detail-left col-12 col-sm-6 col-md-6 col-lg-6">
                                        <div class="bg-color-table mt-20 float-l width-full">
                                            <div class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Created By </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.created_first_name}} {{selected.created_last_name}}</p>
                                                </div>
                                            </div>

                                            <div v-if='selected.is_approved != 2' class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <template v-if='selected.is_approved == 1'>
                                                        <p class="color-333333 heading-text-14 line-height-18"> Approved By </p>
                                                    </template>
                                                    <template v-else>
                                                        <p class="color-333333 heading-text-14 line-height-18"> Denied By </p>
                                                    </template>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.approved_by}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bottom-employee-detail-right col-12 col-sm-6 col-md-6 col-lg-6">
                                        <div class="bg-color-table mt-20 float-l width-full">
                                            <div class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <p class="color-333333 heading-text-14 line-height-18"> Created At </p>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.created_at}} </p>
                                                </div>
                                            </div>

                                            <div v-if='selected.is_approved != 2' class="bus-detail-row width-full float-l">
                                                <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                    <p class="small-bullet center"></p>
                                                </div>
                                                <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                    <template v-if='selected.is_approved == 1'>
                                                        <p class="color-333333 heading-text-14 line-height-18"> Approved At </p>
                                                    </template>
                                                    <template v-else>
                                                        <p class="color-333333 heading-text-14 line-height-18"> Denied At </p>
                                                    </template>
                                                </div>
                                                <div class="col-inner-detail col-number colpie-60 float-l">
                                                    <p class="color-blue heading-text-14 line-height-18"> {{selected.approved_by_action_time}} </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h2 class="mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"> Description </h2>
                                <div class="">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="social-media-description bg-color-table mt-20 mb-20 float-l width-full textOverFlow" v-html='selected.description'></div>
                                    </div>
                                </div>
                                <template v-if="selectedAttachments > 0">
                                    <h2 class="mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"> Attachments <button type="button" id="DownloadAll" class="btn btn-primary pull-right" v-on:click.prevent="downloadAllAttachments(selected.id)">Download All</button></h2>
                                    <div class="">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="social-media-description bg-color-table mt-20 mb-20 float-l width-full">
                                                <template>
                                                    <swiper class="" :options="swiperOptionAttachments" ref="swiperAttachment">
                                                        <template v-for="(doc, index1) in selected.attachments">
                                                            <template v-if="doc.type.toLowerCase() == 'image'">
                                                                <swiper-slide>
                                                                    <img :src="doc.url" @click="openGallery(selected.attachments,index1)">
                                                                </swiper-slide>
                                                            </template>
                                                            <!-- Video file is allowed as 1st file only and after that it wont allow to add any other files -->
                                                            <template v-else-if="doc.type.toLowerCase() == 'video'">
                                                                <swiper-slide>
                                                                    <!--<a :href="doc.url" target="_blank" download><img src="/static/images/video-icon.png" class="link-icon"></a>-->
                                                                    <img v-on:click="downloadImage(doc.url)" src="/static/images/video-icon.png" class="link-icon">
                                                                </swiper-slide>
                                                            </template>
                                                            <template v-else-if="doc.extension.toLowerCase() == 'doc' || doc.extension.toLowerCase() == 'docx'">
                                                                <swiper-slide>
                                                                    <!-- <a :href="doc.url" target="_blank"><img src="/static/images/doc-icon.png" class="link-icon"></a> -->
                                                                    <a href="#" :id="'id' + index1" @click="getSignedUrlPath(doc.url)">
                                                                        <img src="/static/images/doc-icon.png" class="link-icon">
                                                                    </a>
                                                                </swiper-slide>
                                                            </template>
                                                            <template v-else-if="doc.extension.toLowerCase() == 'xls' || doc.extension.toLowerCase() == 'xlsx'">
                                                                <swiper-slide>
                                                                    <!-- <a :href="doc.url" target="_blank"><img src="/static/images/xl-icon.png" class="link-icon"></a> -->
                                                                    <a href="#" :id="'id' + index1" @click="getSignedUrlPath(doc.url)">
                                                                        <img src="/static/images/xl-icon.png" class="link-icon">
                                                                    </a>
                                                                </swiper-slide>
                                                            </template>
                                                            <template v-else-if="doc.extension.toLowerCase() == 'ppt' || doc.extension.toLowerCase() == 'pptx'">
                                                                <swiper-slide>
                                                                    <!-- <a :href="doc.url" target="_blank"><img src="/static/images/ppt-icon.png" class="link-icon"></a> -->
                                                                    <a href="#" :id="'id' + index1" @click="getSignedUrlPath(doc.url)">
                                                                        <img src="/static/images/ppt-icon.png" class="link-icon">
                                                                    </a>
                                                                </swiper-slide>
                                                            </template>
                                                            <template v-else-if="doc.extension.toLowerCase() == 'pdf'">
                                                                <swiper-slide>
                                                                    <!-- <a :href="doc.url" target="_blank"><img src="/static/images/pdf-icon.png" class="link-icon"></a> -->
                                                                    <a href="#" :id="'id' + index1" @click="getSignedUrlPath(doc.url)">
                                                                        <img src="/static/images/pdf-icon.png" class="link-icon">
                                                                    </a>
                                                                </swiper-slide>
                                                            </template>
                                                            <template v-else>
                                                                <swiper-slide>
                                                                    <!-- <a :href="doc.url" target="_blank"><img src="/static/images/link-icon.png" class="link-icon"></a> -->
                                                                    <a href="#" :id="'id' + index1" @click="getSignedUrlPath(doc.url)">
                                                                        <img src="/static/images/link-icon.png" class="link-icon">
                                                                    </a>
                                                                </swiper-slide>
                                                            </template>
                                                        </template>
                                                    </swiper>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-show="swipViews == 0" class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 b-25 calendar-main-section">
                            <div class="nevCalendar">
                                <button id="" class="btn btn-success pull-left" @click="previousMonth" style="margin-left: 5px; padding: 9px 12px;"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
                                <button id="" class="btn btn-success pull-left" @click="nextMonth" style="margin-left: 5px; padding: 9px 12px;"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
                            </div>
                            <button id="refresh" class="btn btn-success pull-right" style="margin-left: 5px; padding: 9px 12px;" @click="refreshEvents"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                            <button id="backToCalendar" class="btn btn-success pull-right" style="margin-left: 5px; padding: 9px 12px;"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            <button type="button" id="openModel" class="btn btn-info btn-lg" data-toggle="modal" data-target="#myModal" style="display: none;">Open Modal</button>
                            <!--Search-->
                            <!--<form class="search-form" role="search">-->
                            <div class="btn btn-success form-group pull-right searchBtn" id="search">
                                <input v-model="searchEvents" type="text" class="form-control searchInput" placeholder="Search">
                                <!--<button type="button" class="form-control form-control-submit">Submit</button>-->
                                <span class="search-label"><i class="fa fa-search"></i></span>
                            </div>
                            <!--</form>-->
                            <!--End Search-->

                            <!--Calendar-->
                            <full-calendar id="SMcalendar" :events="events" :config="config" @day-click="dayClick" @event-selected="eventSelected" ref="calendar">
                                
                            </full-calendar>
                            <div class="clearfix"></div>
                            <!--End Calendar-->

                            <!--Event List-->
                            <div id="list" class="list-group">
                                <template v-for="(text, index) in eventList">
                                    <button @click="loadEvent(text.id)" type="button" class="list-group-item list-group-item-action">{{text.title}}<span class="pull-right">{{text.display_date}}</span></button>
                                </template>
                            </div>
                            <!--End Event List-->

                        </div>
                    </div>
                </div>
            </div>
            <!--bottom-contact-detail-->
            <!-- Modal -->
            <div class="modal fade socialmediacalendarpopup" id="myModal" role="dialog">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-body">
                            <img class="w-100 mb-3" :src="viewImage">
                        </div>
                        <div class="modal-footer">

                            <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('previous')"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                            <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('next')"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                            <!--<a :href="viewImage" target="_blank" download="" class="ml-2 btn btn-primary pull-right themebutton">download</a>-->
                            <button class="ml-2 btn btn-primary pull-right themebutton" type="button"  v-on:click="downloadImage(viewImage)"><i class="fa fa-download" aria-hidden="true"></i></button>
                            <!--<span class="pull-right pt-10 mr-1">{{lightboxImages.length}} / {{(index+1)}}</span>-->
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <section class="internal-page-banner-main col-12">
                <div class="container">
                    <div class="row">
                        <div class="page-title">
                            <h1> Oops! </h1>
                        </div>
                    </div>
                </div>
            </section>
            <div class="internal-page-main-section contact-page-main col-12">
                <!--bottom-contact-detail-->
                <div class="row">
                    <div class="container">
                        <div class="social-media-calendar bottom-employee-detail col-12 float-l">
                            <div class="row">
                                <h2 class="color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full"> 403 </h2>
                                <div class="row">
                                    <div class="bottom-employee-detail-left col-12 col-sm-6 col-md-6 col-lg-6">
                                        <div class="bg-color-table mt-20 mb-40 float-l width-full">
                                            Sorry!, You don't have permission to access this page.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>
<script>
    import Vue from "vue";
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import SessioMixin from '../mixins/sessionmixin';
    import { FullCalendar } from 'vue-full-calendar';
    import 'fullcalendar/dist/fullcalendar.css';
    import { Button } from 'bootstrap-vue/es/components';
    import EventBus from './event-bus';
    import moment from 'moment';

    /* Swiper for submenu tebs start */
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    /* Swiper for submenu tebs end */

    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    import tinymce from 'vue-tinymce-editor';

    import Multiselect from 'vue-multiselect';

    var self;
    export default {
        name: 'contact',
        components: {
            'v-select': vSelect,
            'full-calendar': FullCalendar,
            'datePicker': datePicker,
            'tinymce': tinymce,
            'vueDropzone': vue2Dropzone,
            swiper,
            swiperSlide,
            Multiselect,
        },
        mixins: [SessioMixin],
        data() {
            return {
                isReshare: false,


                // companySocialMedia: [],
                // companySocialMediaArr: [],

                // socialMediaArr: [],
                // socialMedia: '',
                mediaFiles: [],
                socialMediaError: '',
                detailFromEmailId: 0,
                detailFromEmail: [],
                /* FORM ELEMENTS START*/
                loginUserID: 0,
                error: '',
                editEventID: 0,
                title: '',
                titleError: '',
                description: '',
                descriptionError: '',
                charCountError: '',
                filesCountError: 'Max file you can upload 6',
                hashTag: '',
                //Files
                imagesPaths: [],
                imagesType: [],
                imagesSize: [],
                loadDocArr: [],
                companies: '',
                // companyArr: [],
                companyError: '',
                startDateForm: new Date(),
                startTimeForm: new Date(),
                startDateError: '',
                StartTimeError: '',
                userId: '',
                contactPersonError: '',
                contactEmail: '',
                contactEmailError: '',
                contactNumber: '',
                contactNumberError: '',
                createdByTitle: '',
                createdBy: '',
                optionsStart: {
                    format: 'MM/DD/YYYY',

                    /*format: 'MM/DD/YYYY hh:mmA',
                     dayViewHeaderFormat: 'MMM DD YYYY hh:mm',
                     minDate: new Date(),
                     minDate: new Date(new Date().setDate(new Date().getDate() - 1)),
                     maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1000)),*/
                },
                optionsTime: {
                    format: 'HH:mm:ss',

                    /*format: 'MM/DD/YYYY hh:mmA',
                     dayViewHeaderFormat: 'MMM DD YYYY hh:mm',
                     minDate: new Date(),
                     minDate: new Date(new Date().setDate(new Date().getDate() - 1)),
                     maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1000)),*/
                },
                dropzoneOptions: {
                    //timeout: 3000000,
                    url: process.env.ROOT_API + "/store_document",
                    method: "POST",
                    paramName: 'file',
                    parallelUploads: 1,
                    autoProcessQueue: true,
                    maxFilesize: 1024, // 1GB in MB
                    maxFiles: 6,
                    dictFileTooBig: "File is too big ({{filesize}}MB). Max allowed file size is 1GB",
                    thumbnailWidth: 150, //px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    dictCancelUpload: 'Cancel',
                    dictRemoveFile: "Remove",
                    // acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    }
                },
                /* FORM ELEMENTS END*/
                isShowLoggedinfields: true,
                userPermissions: ['access_social_media_calendar'],
                roleId: 0,
                roleName: 0,
                system_year: '',
                swiperOptionAttachments: {
                    slidesPerView: 14.5,
                    spaceBetween: 8,
                    freeMode: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1500: {
                            slidesPerView: 12.5
                        },
                        1400: {
                            slidesPerView: 11.5
                        },
                        1300: {
                            slidesPerView: 10.4
                        },
                        1200: {
                            slidesPerView: 8.5
                        },
                        1000: {
                            slidesPerView: 7.5
                        },
                        667: {
                            slidesPerView: 5.5
                        },
                        480: {
                            slidesPerView: 3.5
                        },
                        360: {
                            slidesPerView: 3.4
                        }
                    }
                },
                lightboxImages: [],
                viewImage: '',
                index: 0,
                swipViews: 0,
                startDate: 0,
                endData: 0,
                config: {
                    /*'weekends': false,*/
                    defaultDate: moment(new Date()).format("MM/DD/YYYY"),
                    defaultView: 'month',
                    displayEventTime: false,
                    editable: false,
                    eventLimit: true,
                    noEventsMessage: "Social Media Calendar Entries Not Available",
                    eventClick: (event) => {
                    //   console.log("event === ",event.start_date_time);
                        this.selected = event;
                        //this.showModel();
                        this.selectedAttachments = this.selected.attachments.length;
                        this.showDetails();
                    },
                    dayClick: (date, jsEvent, view) => {
                        // console.log('day click within config')
                      if(self.userPermissions.indexOf('post_social_media') > -1 ||
                      self.userPermissions.indexOf('draft_social_media') > -1 ||
                      self.userPermissions.indexOf('post_social_media') > -1) {

                        // console.log("data ===", date._d);

                        // if(date == new Date()) {
                        //   self.startDateForm = new Date();
                        // } else {
                        //   self.startDateForm = date;
                        // }

                        this.swipViews = 2;
                        this.editEventID = 0;
                        // this.startDateForm = moment(date).format("MM/DD/YYYY HH:mm:ss");
                        $("#addSocialMediaBtn").val("Save");
                        $("#publishNowSocialMediaBtn").val("Publish Now");
                        $("#draftSocialMediaBtn").val("Draft");

                        this.createdByTitle = 'Created By';
                        this.formTitle = 'Add Social Media Calender Entry';
                        this.scrollToTop();
                      }

                      var d = new Date();
                      self.startDateForm = moment(date).format("MM/DD/YYYY");// + " " + d.getHours() +  ":" + d.getMinutes() +  ":" + d.getSeconds();
                      self.startTimeForm = "";
                      self.$refs.dropzone.removeAllFiles()

                        /*console.log(this.startDateForm);
                         console.log(jsEvent);
                         console.log(view);*/
                    },
                    header: {
                        /*left: 'prev,next',*/
                        left: '',
                        center: 'title',
                        right: 'month,listMonth',
                    },
                    buttonText: {
                        /*'prev': 'Previous',
                         'next': 'Next',*/
                        'month': 'Month',
                        'listMonth': 'List',
                    }
                },
                events: [],
                selected: {},
                formTitle: "Add Social Media Calender Entry",
                selectedAttachments: 0,
                eventList: [],
                searchEvents: '',
                charLimit: 700,
                charLimitError: '',
                createdByUserName : '',
                is_approved : 0,
                approvedByUserName : '',
                approvedByTime : ''
            }
        },
        watch: {
            description: function (description) {
                /*self.descriptionError = (description.length > 0) ? "" : "Description Required";*/
                if (description.length > 0) {
                    self.descriptionError = "";
                }
            },
            searchEvents: function (searchEvents) {
                self.searchEvent();
            }
        },
        beforeMount: function () {
            self = this;
            self.role.id = 0;
            self.checkLogin();
        },
        mounted: function () {
            self.getBuildVersion();
            // console.log(this.startDateForm);
            // self.startDateForm = new Date();
            // console.log("mount =", self.startDateForm);
            self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
            self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
            if (typeof (this.$route.query.id) != "undefined") {
                self.detailFromEmailId = this.$route.query.id;
                self.loadEventDetails();
            }
            self.MenuClose();
            self.getPermissions();
            self.loadCalendarEvents();
            self.formTitle = 'Add Social Media Calender Entry';
            /*self.searchEvent();*/

//            Hide Initially
            $("#list").hide();
            $("#backToCalendar").hide();

            $("#link").click(function () {
                $('#myModal').modal('toggle');
            });

            $(document).ready(function () {
                $('#search').on("click", (function (e) {
                    $(".searchBtn").addClass("sb-search-open");
                    $("#SMcalendar").hide();
                    $("#refresh").hide();
                    $(".nevCalendar").hide();
                    $("#backToCalendar").show();
                    $("#list").show();
                    e.stopPropagation();
                }));
                $('#backToCalendar').on("click", (function (e) {
                    $(".searchBtn").removeClass("sb-search-open");
                    $("#SMcalendar").show();
                    $("#refresh").show();
                    $(".nevCalendar").show();
                    self.searchEvents = '';
                    $("#backToCalendar").hide();
                    $("#list").hide();
                    e.stopPropagation();
                }));
            });
            /* FORM CODE START*/
            var userObj = localStorage.getItem("user_obj");
            var userJson = [];
            if (userObj != null) {
                userJson = JSON.parse(userObj);
                self.loginUserID = userJson.id;
            } else {
                self.$router.push("/login");
            }
            $("#title").on('keyup', function () {
                self.titleError = '';
            });
            // self.loadCompanies();
            // self.getCompanyWithSocialMedia();
            $("#companies").on('keyup', function () {
                self.companyError = '';
            });
            $("#startDate").on('keyup', function () {
                self.startDateError = '';
            });
            $("#startTime").on('keyup', function () {
                self.startTimeError = '';
            });
            self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
            $("#userId").on('keyup', function () {
                self.contactPersonError = '';
            });
            self.contactEmail = userJson.email;
            $("#contactEmail").on('keyup', function () {
                self.contactEmailError = '';
            });
            self.contactNumber = userJson.phone;
            $("#contactNumber").on('keyup', function () {
                self.contactNumberError = '';
            });
            self.createdByTitle = 'Created By';
            $("#alertError").hide();
            /* FORM CODE END*/
        },
        methods: {
            getCompanyWithSocialMedia: function () {
              var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                };
                HTTP.get('/getcompany/socialmedia', config)
                    .then(response => {
                      console.log("cate ===", response.data.content);
                    //   self.companySocialMediaArr = response.data.content;
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });

            },
            getSocialMediaPlatformName: function(media) {
              var  text = "";
              if(media != null) {
                for (var i = 0; i < media.length; i++) {
                  text += self.capitalizeFirstLetter(media[i].name)  + '\n';
                }
              }
              return text;
            },
            getSocialMediaForCompany: function() {
              var config = {
                  headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                  params: {
                      company_id: self.companies[self.companies.length - 1].value
                  }
              };
              HTTP.get("socialmedia/company", config)
                  .then(function (response) {
                      // self.socialMediaArr = [];
                      // self.socialMediaArr = response.data;
                      $.each(response.data, function (i) {
                        if(self.socialMediaArr.length > 0) {
                          var idx = self.socialMediaArr.findIndex(obj => obj.id == response.data[i].id)
                          if(idx == -1) {
                            self.socialMediaArr.push(response.data[i]);
                          }
                        } else {
                          self.socialMediaArr.push(response.data[i]);
                        }
                        // console.log(idx);
                        // self.socialMediaArr.push(response.data[i]);
                          /*self.companyArr.push(response.data.content[i].text);*/
                          // if(self.socialMediaArr == null) {
                          //   self.socialMediaArr.push(response.data[i]);
                          // } else {
                          //   var idx = self.socialMediaArr.findIndex(obj => obj.company_id == response.data[i].company_id)
                          //   if(idx != -1) {
                          //     self.socialMediaArr.push(response.data[i]);
                          //   }
                          // }
                      });
                      console.log(JSON.stringify(self.socialMediaArr));
                  })
                  .catch(function (err) {
                      if (err.response.status == 0) {
                          self.error = "Remote server can not be reachable";
                      } else {
                          //redirect to login page if user not authenticated
                          if (err.response.status == 401) {
                              //clear previous data
                              localStorage.removeItem("user_obj");
                              localStorage.removeItem("api_token");
                              localStorage.removeItem("profile_image");
                              self.$router.push("/login");
                              //EventBus.$emit("logged-in", true, "", "");
                          }
                          self.error = err.response.data.message;
                      }
                  });
                // }
            },
            /*FORM CODE START*/
            // loadCompanies(search) {

            //     var config = {
            //         //headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
            //         params: {
            //             search: search
            //         }
            //     };
            //     HTTP.get("getcompany", config)
            //             .then(function (response) {
            //                 self.companyArr = [];
            //                 $.each(response.data.content, function (i) {
            //                     /*self.companyArr.push(response.data.content[i].text);*/
            //                     self.companyArr.push(response.data.content[i]);
            //                 });
            //             })
            //             .catch(function (err) {
            //                 if (err.response.status == 0) {
            //                     self.error = "Remote server can not be reachable";
            //                 } else {
            //                     //redirect to login page if user not authenticated
            //                     if (err.response.status == 401) {
            //                         //clear previous data
            //                         localStorage.removeItem("user_obj");
            //                         localStorage.removeItem("api_token");
            //                         localStorage.removeItem("profile_image");
            //                         self.$router.push("/login");
            //                         //EventBus.$emit("logged-in", true, "", "");
            //                     }
            //                     self.error = err.response.data.message;
            //                 }
            //             });
            // },
            checkForm: function () {
                var checked = true;
                self.titleError = "";
                if (!self.title) {
                    self.titleError = "Title Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.title.length > 190) {
                    self.titleError = "Title cannot be longer than 190 character";
                    if (checked) {
                        checked = false;
                    }
                }
                self.descriptionError = "";
                if (!self.description) {
                    self.descriptionError = "Description Required";
                    if (checked) {
                        checked = false;
                    }
                }

                // self.companyError = "";
                // if (self.companySocialMedia.length === 0) {
                //     self.companyError = "Company Required";
                //     if (checked) {
                //         checked = false;
                //     }
                // }
                self.startDateError = "";
                if (!self.startDateForm) {
                    self.startDateError = "Date Required";
                    if (checked) {
                        checked = false;
                    }
                }
                // self.startTimeError = "";
                // if (!self.startTimeForm) {
                //     self.startTimeError = "Time Required";
                //     if (checked) {
                //         checked = false;
                //     }
                // }

                self.contactPersonError = "";
                if (!self.userId) {
                    self.contactPersonError = 'Please Enter Contact Person';
                    if (checked) {
                        checked = false;
                    }
                }
                self.contactEmailError = "";
                if (!self.contactEmail) {
                    self.contactEmailError = 'Please Enter Contact Email';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.contactEmail && !self.validEmail(self.contactEmail)) {
                    self.contactEmailError = 'Please Enter Valid Contact Email';
                    if (checked) {
                        checked = false;
                    }
                }
                self.contactNumberError = "";
                if (self.contactNumber && !String(self.contactNumber).match(/^[0-9]*$/)) {
                    self.contactNumberError = "Phone Number Must Be Numeric";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactNumber && String(self.contactNumber).match(/^[0-9]*$/) && self.contactNumber.length < 10) {
                    self.contactNumberError = "Phone Number Must Be Of Minimum 10 Digits";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactNumber && String(self.contactNumber).match(/^[0-9]*$/) && self.contactNumber.length > 13) {
                    self.contactNumberError = "Phone Number Must Be Of Maximum 13 Digits";
                    if (checked) {
                        checked = false;
                    }
                }


                // self.startTimeError = "";
                // if (!self.startTimeForm) {
                //     self.startTimeError = 'Please Enter Time';
                //     if (checked) {
                //         checked = false;
                //     }
                // }


                var countChar = (self.hashTag.length + self.description.length);
                var remain =  self.charLimit - countChar;
                self.charLimitError = "";
                if (remain < 0) {
                    self.charLimitError = "Post Character limit out of bound";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },
            fileUploadProcessDone: function () {
                $("#addSocialMediaBtn").prop("disabled", false);
                $("#draftSocialMediaBtn").prop("disabled", false);
                $("#CancelSocialMedia").prop("disabled", false);
                $("#publishNowSocialMediaBtn").prop("disabled", false);
            },
            uploadDocument: function (file, response) {
                // Video file is allowed as 1st file only and after that it wont allow to add any other files
                // console.log("upload DONE",response);
                var self = this;
                /* self.isFileUploaded = true; */
                self.imagesPaths.push(response.content);
                // console.log("dadad =- ",self.imagesPaths);
                self.imagesType.push(file.type);
                self.imagesSize.push(file.size);
                self.mediaFiles.push(file);

                if(self.mediaFiles.length > 1) {
                  if(file.type.includes("video")) {
                    this.removedSelectedFile(file, file.xhr, null);
                  }
                }

                // $("#addSocialMediaBtn").prop("disabled", false);
                // $("#draftSocialMediaBtn").prop("disabled", false);
                // $("#CancelSocialMedia").prop("disabled", false);
                // $("#publishNowSocialMediaBtn").prop("disabled", false);

                // console.log("set on edit upload max second == ",this.$refs.dropzone.dropzone.options.maxFiles);
                // console.log("total files == ",self.$refs.dropzone.dropzone.getAcceptedFiles().length);

                if(self.$refs.dropzone.dropzone.files.length > this.$refs.dropzone.dropzone.options.maxFiles) {
                  //this.removedSelectedFile(file, file.xhr, null);
                }


            },
            removedSelectedFile: function (file, xhr, error) {
            //   console.log("remove ", file);
              var self = this;
                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */
                // this.$refs.dropzone.setOption('maxFiles', 1);
                // if(file.type.includes("video")) {
                //   this.$refs.dropzone.setOption('maxFiles', 1);
                // } else {
                //   this.$refs.dropzone.setOption('maxFiles', 6);
                // }
                // console.log("remove ==", this.mediaFiles);
                // var idx = this.mediaFiles.findIndex(obj => obj == file);

                // if(idx !== -1) {
                //   this.mediaFiles.splice(idx,1);
                //   this.$refs.dropzone.removeFile(file)
                // }

                // if(this.mediaFiles.length == 0) {
                //   this.$refs.dropzone.setOption('maxFiles', 6);
                //   self.filesCountError =  'Max file you can upload 6';
                //   self.charLimit = 700;
                // }


                var removeFile = "";
                // if (this.$refs.dropzone.dropzone.options.maxFiles) {
                //     this.$refs.dropzone.setOption('maxFiles', 1);
                // }
                /* if (self.imagesPaths.length <= 0) {
                 self.isFileUploaded = false;
                 } */
                if ("manuallyAdded" in file == true) {
                    for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                        if (self.imagesPaths[i].indexOf(file.name) != -1) {
                            removeFile = self.imagesPaths[i];
                        }
                    }
                    // this.$refs.dropzone.setOption('maxFiles', 1);
                } else {
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content;
                    self.removeFileFromServer(removeFile);
                }
                for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                    if (self.imagesPaths[i] === removeFile) {
                        self.imagesPaths.splice(i, 1);
                        self.imagesType.splice(i, 1);
                        self.imagesSize.splice(i, 1);
                        self.mediaFiles.splice(i, 1);
                        //break;       //<-- Uncomment  if only the first term has to be removed
                    }
                }

                // var idx = self.companySocialMedia.findIndex(obj => obj.name.includes("twitter"));
                // if(idx !== -1) {
                //   this.$refs.dropzone.setOption('maxFiles', 4);
                //   self.filesCountError =  'Max file you can upload 4 because you have selected twitter in company and social media';
                  
                // }

                // if(this.mediaFiles.length == 0) {
                //   this.$refs.dropzone.setOption('acceptedFiles', "image/* , video/*");
                // }
                // this.$refs.dropzone.dropzone.options.acceptedFiles = "";
                // console.log("file type =", this.$refs.dropzone.dropzone.options.acceptedFiles);
                // this.$refs.dropzone.setOption('maxFiles', 1);
                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */
            },
            removeFileFromServer: function (filePath) {
                var self = this;
                //console.log(filePath);return false;
                var config = {
                    headers: {"Authorization": "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            //self.catchHandler(err, function () {});
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            fileError: function (file, xhr, error) {
                /* console.log("File Error"); */
                // console.log("File Error = ", file);
                $("#addSocialMediaBtn").prop("disabled", false);
                $("#draftSocialMediaBtn").prop("disabled", false);
                $("#CancelSocialMedia").prop("disabled", false);
                $("#publishNowSocialMediaBtn").prop("disabled", false);
            },
            disableButtons: function (file) {
                    $("#addSocialMediaBtn").prop("disabled", true);
                    $("#draftSocialMediaBtn").prop("disabled", true);
                    $("#CancelSocialMedia").prop("disabled", true);
                    $("#publishNowSocialMediaBtn").prop("disabled", true);

            },
            fileAdd: function (file, xhr, error) {
            //   console.log("File Add START" , this.$refs.dropzone.dropzone.options.maxFiles);
              // console.log("File Add files" , this.$refs.dropzone.dropzone.files.length);
                    

            //   $("#addSocialMediaBtn").prop("disabled", true);
            //   $("#draftSocialMediaBtn").prop("disabled", true);
            //   $("#CancelSocialMedia").prop("disabled", true);
            //   $("#publishNowSocialMediaBtn").prop("disabled", true);

            // Video file is allowed as 1st file only and after that it wont allow to add any other files

              if(self.imagesType.length == 0) {
                if(file && file.type && file.type.includes("video")) {
                  this.$refs.dropzone.setOption('maxFiles', 1);
                  self.filesCountError =  'Max file you can upload 1 because you have uploaded video';
                } else {
                  this.$refs.dropzone.setOption('maxFiles', 6);
                  self.filesCountError =  'Max file you can upload 6';
                }
              } else {
                if(file && file.type && file.type.includes("video")) {
                  // this.fileError(file, xhr, error);
                } else {
                //   var idx = self.companySocialMedia.findIndex(obj => obj.name.includes("facebook"));
                //   if(idx !== -1) {
                //     this.$refs.dropzone.setOption('maxFiles', 6);
                //     self.filesCountError =  'Max file you can upload 6';
                //     self.charLimit = 700;
                //   }
                //   var idx = self.companySocialMedia.findIndex(obj => obj.name.includes("linkedin"));
                //   if(idx !== -1) {
                //     this.$refs.dropzone.setOption('maxFiles', 6);
                //     self.filesCountError =  'Max file you can upload 6';
                //     self.charLimit = 700;
                //   }
                //   var idx = self.companySocialMedia.findIndex(obj => obj.name.includes("twitter"));
                //   if(idx !== -1) {
                //     this.$refs.dropzone.setOption('maxFiles', 4);
                //     self.filesCountError =  'Max file you can upload 4 because you have selected twitter in company and social media';
                //     self.charLimit = 279;
                //   } else {
                //     this.$refs.dropzone.setOption('maxFiles', 6);
                //     self.filesCountError =  'Max file you can upload 6';
                //     self.charLimit = 700;

                //   }

                }
              }
              // console.log("set on edit max == ",this.$refs.dropzone.dropzone.options.maxFiles);
            },
            uploadManually: function (file) {
                
                // console.log("set on edit upload max first == ",this.$refs.dropzone.dropzone.options.maxFiles);
                var self = this;
                // console.log("upload count = ", self.loadDocArr.length);
                for (var i = 0; i < self.loadDocArr.length; i++) {

                    var url = self.loadDocArr[i]['url'];
                    var file_name = self.getFileName(self.loadDocArr[i]['url']);
                    var file_type = self.loadDocArr[i]['file_type'];
                    var file_size = self.loadDocArr[i]['size'];

                    self.imagesType.push(file_type);
                    self.imagesSize.push(Number(file_size));

                    console.log("hello",url);
                    console.log(file_name);
                    console.log(file_type);
                    console.log(file_size);

                    var file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);

                    // var newCount = this.$refs.dropzone.dropzone.options.maxFiles - i;
                    // console.log("newCount = ", newCount);
                    // this.$refs.dropzone.setOption('maxFiles', newCount);

                    self.mediaFiles.push(file_data);
                    if(self.isReshare == true) {
                      // self.fileAdd(file_data, null, null);
                    }
                    // $("#addSocialMediaBtn").prop("disabled", false);
                    // $("#draftSocialMediaBtn").prop("disabled", false);
                    // $("#CancelSocialMedia").prop("disabled", false);
                    // $("#publishNowSocialMediaBtn").prop("disabled", false);
                }
                // self.$refs.dropzone.dropzone.setOption.fu = self.loadDocArr.length;
                // this.$refs.dropzone.setOption('maxFiles', self.loadDocArr.length);
                // console.log("set on edit upload max second == ",this.$refs.dropzone.dropzone.options.maxFiles);
                // console.log("total files == ",self.$refs.dropzone.dropzone.files.length);
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },
            getFileName: function (file) {
                var self = this;
                var src = file.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2]
                self.imagesPaths.push(String(orgPath + "/" + file_name));
                return file_name;
            },
            removeAllFiles: function () {
                self.$refs.dropzone.removeAllFiles();
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            changedValue: function (value) {
                // console.log(value);
                // self.getSocialMediaForCompany();
            },
            changedValueCompany: function () {
                self.companyError = "";
                if(self.companies != null && self.companies != '') {
                  self.getSocialMediaForCompany();
                } else {
                  // self.socialMediaArr = [];
                  // self.socialMedia = '';
                }

            },
            charCount: function(){
              var countChar = (self.hashTag.length + self.description.length);
              var remain =  self.charLimit - countChar;
              self.charCountError = 'Character = ' + remain; //countChar + "/" +
            },
            changedValueSocialMedia: function () {
              console.log("changedValueSocialMedia");
              if(self.companySocialMedia.length > 0) {

                var idx = self.companySocialMedia.findIndex(obj => obj.name.includes("facebook"));
                if(idx !== -1) {
                  this.$refs.dropzone.setOption('maxFiles', 6);
                  self.filesCountError =  'Max file you can upload 6';
                  self.charLimit = 700;
                  self.charCount();
                }
                var idx = self.companySocialMedia.findIndex(obj => obj.name.includes("linkedin"));
                if(idx !== -1) {
                  this.$refs.dropzone.setOption('maxFiles', 6);
                  self.filesCountError =  'Max file you can upload 6';
                  self.charLimit = 700;
                  self.charCount();
                }
                var idx = self.companySocialMedia.findIndex(obj => obj.name.includes("twitter"));
                if(idx !== -1) {
                  this.$refs.dropzone.setOption('maxFiles', 4);
                  self.filesCountError =  'Max file you can upload 4 because you have selected twitter in company and social media';
                  self.charLimit = 279;
                  self.charCount();
                } else {
                  this.$refs.dropzone.setOption('maxFiles', 6);
                  self.filesCountError =  'Max file you can upload 6';
                  self.charLimit = 700;
                  self.charCount();
                }
              } else {
                this.$refs.dropzone.setOption('maxFiles', 6);
                self.filesCountError =  'Max file you can upload 6';
                self.charLimit = 700;
                self.charCount();
              }

              if(this.$refs.dropzone.dropzone.options.maxFiles < this.mediaFiles.length) {
                console.log("REMOVE EXTRA FILE");

                var indx = this.mediaFiles.length - this.$refs.dropzone.dropzone.options.maxFiles;
                console.log("REMOVE EXTRA FILE ", indx);


                for (let index = 0; index < indx; index++) {
                  // const element = array[index];
                  console.log("call = ", index);
                  self.removedSelectedFile(this.mediaFiles[this.mediaFiles.length - 1], this.mediaFiles[this.mediaFiles.length - 1].xhr, null);
                }
              } else {
                console.log("NO NEED TO REMOVE");
              }

              self.socialMediaError = "";
            },
            changeStartDt: function () {
              var currentDate =  moment(new Date()).format("MM/DD/YYYY");
              if(currentDate ==  self.startDateForm) {
                $("#publishNowSocialMediaBtn").show();
              } else {
                $("#publishNowSocialMediaBtn").hide();
              }
              self.startDateError = "";
            },
            changeTimeDt: function () {
                self.startTimeError = "";
            },
            addEvent(status) {
              console.log("status ==", status);
              // console.log("status ==", self.isReshare);
              console.log("time == ", self.startTimeForm);
              console.log("date == ", self.startDateForm);
              if(self.startTimeForm != null) {
                var start_date = self.startDateForm + " " + self.startTimeForm;
              } else {
                var start_date = self.startDateForm + " " + "00:00:00";
              }
              console.log("aadd == ", start_date);
              if(self.isReshare == true) {
                self.editEventID = 0;
              }

                if (self.checkForm()) {
                    var userJson = [];
                    var userObj = localStorage.getItem("user_obj");
                    if (userObj != null) {
                        userJson = JSON.parse(userObj);
                    } else {
                        self.$router.push("/login");
                    }
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    // var companiesId = '';
                    // for (var i = 0; i < self.companies.length; i++) {
                    //     companiesId += (self.companies[i].value) + ',';
                    // }
                    // for (var i = 0; i < self.companySocialMedia.length; i++) {
                    //     companiesId += (self.companySocialMedia[i].company_id) + ',';
                    // }

                    // var companiesWithId = [];
                    // for (var i = 0; i < self.companies.length; i++) {

                    //   var company = "";
                    //   var social = "";
                    //   var idx = self.socialMedia.findIndex(obj => obj.company_id == self.companies[i].value)
                    //   if(idx != -1) {
                    //     company = self.socialMedia[idx].company_id;
                    //     social = self.socialMedia[idx].id;
                    //     companiesWithId.push({
                    //       company_id : company,
                    //       social_media : social,
                    //     })
                    //   }
                    // }

                    // for (var i = 0; i < self.companySocialMedia.length; i++) {

                    //   companiesWithId.push({
                    //     company_id : self.companySocialMedia[i].company_id,
                    //     social_media : self.companySocialMedia[i].id,
                    //   });
                    // }

                    // companiesId = companiesId.replace(/,\s*$/, "");



                    var post_now = 0;

                    if(status === "publish_now") {
                      status = "post";
                      post_now = 1;
                    }

                    if(self.startTimeForm != null) {
                      var start_date = self.startDateForm + " " + self.startTimeForm;
                    } else {
                      var start_date = self.startDateForm + " " + "00:00:00";
                      status = "Time Missing"
                    }

                    if(post_now == 1) {
                      var d = new Date();
                      var start_date = self.startDateForm + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
                    }




                    console.log("aadd == ", start_date);
                    console.log("status ==)))", status);
                    if (self.editEventID == 0) {
                        var data = {
                            title: self.title,
                            imagePath: self.imagesPaths,
                            imageSize: self.imagesSize,
                            imageType: self.imagesType,
                            // companies_id: companiesId,
                            description: self.description,
                            hashtag: self.hashTag,
                            startDate: start_date,
                            contactPerson: self.userId,
                            contactEmail: self.contactEmail,
                            contactNumber: self.contactNumber,
                            status: status,
                            // social_medias: self.companySocialMedia,
                            reshare: self.isReshare,
                            post_now: post_now,
                        };
                        if(status == 'draft') {
                          $("#draftSocialMediaBtn").val("Draft ...");
                        } else {
                          if(self.isReshare == true) {
                              if(status != "post"){
                                $("#addSocialMediaBtn").val("Resharing ...");
                              }else{
                                  //$("#publishNowSocialMediaBtn").val("Publishing ...");
                              }
                            
                          } else {
                            if(post_now == 1) {
                              $("#publishNowSocialMediaBtn").val("Publishing ...");
                            } else {
                              $("#addSocialMediaBtn").val("Saving ...");
                            }

                          }
                          // $("#addSocialMediaBtn").val("Saving ...");
                        }

                    } else {
                        var data = {
                            title: self.title,
                            imagePath: self.imagesPaths,
                            imageSize: self.imagesSize,
                            imageType: self.imagesType,
                            // companies_id: companiesId,
                            description: self.description,
                            hashtag: self.hashTag,
                            startDate: start_date,
                            contactPerson: self.userId,
                            contactEmail: self.contactEmail,
                            contactNumber: self.contactNumber,
                            id: self.editEventID,
                            status: status,
                            // social_medias: self.companySocialMedia,
                            reshare: self.isReshare,
                            post_now: post_now,
                        };
                        if(status == 'draft') {
                          $("#draftSocialMediaBtn").val("Draft ...");
                        } else {
                          $("#addSocialMediaBtn").val("Updating ...");
                        }

                    }
                    $("#addSocialMediaBtn").prop("disabled", true);
                    $("#publishNowSocialMediaBtn").prop("disabled", true);
                    $("#draftSocialMediaBtn").prop("disabled", true);
                    $("#CancelSocialMedia").prop("disabled", true);
                    HTTP.post("addupdatesocialmedia", data, config)
                            .then(function (response) {
                                // self.removeAllFiles();
                                if (self.editEventID == 0) {

                                    if(post_now == 1) {
                                      $("#publishNowSocialMediaBtn").val("Publish Now");
                                    } else {
                                      $("#addSocialMediaBtn").val("Save");
                                    }
                                } else {
                                  if(status == 'draft') {
                                    $("#draftSocialMediaBtn").val("Draft");
                                  } else {
                                    $("#addSocialMediaBtn").val("Update");
                                  }

                                }
                                $("#addSocialMediaBtn").prop("disabled", false);
                                $("#publishNowSocialMediaBtn").prop("disabled", false);
                                $("#draftSocialMediaBtn").prop("disabled", false);
                                $("#CancelSocialMedia").prop("disabled", false);
                                self.$refs.dropzone.removeAllFiles();
                                if (response.data.message == "success") {
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    self.title = '';
                                    // self.companies = '';
                                    // self.companySocialMedia = '';
                                    self.description = '';
                                    self.hashTag = '';
                                    self.startDateForm = new Date().toLocaleString();
                                    var d = new Date();
                                    self.startTimeForm = d.getHours() +  ":" + d.getMinutes() +  ":" + d.getSeconds();
                                    //
                                    console.log("add env =", self.startDateForm);
                                    self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
                                    self.contactEmail = userJson.email;
                                    self.contactNumber = userJson.phone;
                                    self.userArr = [];
                                    self.imagesPaths = [];
                                    self.imagesSize = [];
                                    self.imagesType = [];
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        self.buttonBack(2);
                                    }, 3000);
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        self.buttonBack(2);
                                    }, 5000);
                                }
                            })
                            .catch(function (err) {
                                // self.removeAllFiles();
                                if (self.editEventID == 0) {
                                  if(status == 'draft') {
                                    $("#draftSocialMediaBtn").val("Draft");
                                  } else {
                                    if(post_now == 1) {
                                      $("#publishNowSocialMediaBtn").val("Publish Now");
                                    } else {
                                      $("#addSocialMediaBtn").val("Save");
                                    }

                                  }

                                } else {
                                  if(status == 'draft') {
                                    $("#draftSocialMediaBtn").val("Draft");
                                  } else {
                                    $("#addSocialMediaBtn").val("Update");
                                  }
                                }
                                $("#addSocialMediaBtn").prop("disabled", false);
                                $("#draftSocialMediaBtn").prop("disabled", false);
                                $("#CancelSocialMedia").prop("disabled", false);
                                $("#errorMsg").html(err.response.data.message);
                                $(".alert-danger").removeClass("hide");
                                $(".alert-danger").addClass("show");
                                setTimeout(function () {
                                    $(".alert-danger").removeClass("show");
                                    $(".alert-danger").addClass("hide");
                                }, 5000);
                                if (err.response.status == 0) {
                                    self.errorMsg = "Remote server can not be reachable";
                                } else {
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                    }
                                    $("#errorMsg").html(err.response.data.message);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                            });

                }
            },
            editEvent(eventID, isReSend) {
            //   console.log("isReSend = ", isReSend)
                self.editEventID = eventID;
                /*self.createdByTitle = 'Last Updated By';*/
                self.createdByTitle = 'Updated By';
                self.$refs.dropzone.removeAllFiles()
                self.loadEventEdit();
                if(isReSend == true) {
                  self.isReshare = true;
                  self.formTitle = 'Re-Share Social Media Calender Entry';
                  $("#addSocialMediaBtn").val("Re-share");
                } else {
                  self.isReshare = false;
                  self.formTitle = 'Edit Social Media Calender Entry';
                  $("#addSocialMediaBtn").val("Update");
                }

                self.scrollToTop();
            },
            loadEventEdit() {
                // console.log("LOAD ");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: self.editEventID,
                    }
                };
                HTTP.get("getsocialentry", config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                          console.log(response.data.content);
                            self.title = response.data.content.title;
                            self.description = response.data.content.description;
                            self.hashTag = response.data.content.has_tags;
                            self.userId = response.data.content.contact_person;
                            self.contactEmail = response.data.content.contact_email;
                            self.contactNumber = response.data.content.contact_number;
                            self.createdBy = response.data.content.last_updated_by;
                            self.createdByUserName = response.data.content.created_by;
                            self.is_approved = response.data.content.is_approved;
                            
                            if(response.data.content.is_approved_by && response.data.content.is_approved_by != null) {
                                self.approvedByUserName = response.data.content.is_approved_by;
                            }
                            if(response.data.content.is_approve_action_time && response.data.content.is_approve_action_time != null) {
                                self.approvedByTime = response.data.content.is_approve_action_time;
                            }
                            
                            var userJson = [];
                            var userObj = localStorage.getItem("user_obj");
                            if (userObj != null) {
                                userJson = JSON.parse(userObj);
                            } else {
                                self.$router.push("/login");
                            }
                            self.createdBy = userJson.first_name + " " + userJson.last_name;
                            // self.companySocialMedia = response.data.content.social_media;
                            // if(self.companySocialMedia.length > 0) {
                                // var idx = self.companySocialMedia.findIndex(obj => obj.name.includes("facebook"));
                                // if(idx !== -1) {
                                //     this.$refs.dropzone.setOption('maxFiles', 6);
                                //     self.charLimit = 700;
                                //     self.charCount();
                                // }
                                // var idx = self.companySocialMedia.findIndex(obj => obj.name.includes("linkedin"));
                                // if(idx !== -1) {
                                //     this.$refs.dropzone.setOption('maxFiles', 6);
                                //     self.charLimit = 700;
                                //     self.charCount();
                                // }
                                // var idx = self.companySocialMedia.findIndex(obj => obj.name.includes("twitter"));
                                // if(idx !== -1) {
                                //     self.$refs.dropzone.setOption('maxFiles', 4);
                                //     self.filesCountError =  'Max file you can upload 4 because you have selected twitter in company and social media';
                                //     self.charLimit = 279;
                                //     self.charCount();
                                // } else {
                                //     self.$refs.dropzone.setOption('maxFiles', 6);
                                //     self.filesCountError =  'Max file you can upload 6';
                                //     self.charLimit = 700;
                                //     self.charCount();
                                // }
                            // } else {
                            //     self.$refs.dropzone.setOption('maxFiles', 6);
                            //     self.filesCountError =  'Max file you can upload 6';
                            //     self.charLimit = 700;
                            //     self.charCount();
                            // }
                            // console.log(self.companySocialMedia);
                            self.loadDocArr = response.data.content.attachments;
                            self.uploadManually();
                            // self.companies = [];

                            // for (var i = 0; i < response.data.content.selected_company.length; i++) {
                            //     self.companies.push({'text': response.data.content.selected_company[i].name, 'value': response.data.content.selected_company[i].id});
                            // }
                            // self.socialMedia = response.data.content.social_media;
                            // for (var i = 0; i < response.data.content.social_media.length; i++) {
                            //     self.socialMedia.push(response.data.content.social_media[i]);
                            // }


                            setTimeout(function () {
                              if(self.isReshare == true) {
                                self.startDateForm = new Date();
                                var d = new Date();
                                self.startTimeForm = d.getHours() +  ":" + d.getMinutes() +  ":" + d.getSeconds();
                              } else {
                                self.startDateForm = moment(response.data.content.start_date_time).format("MM/DD/YYYY");
                                if(response.data.content.status == "Time Missing") {
                                  self.startTimeForm = "";
                                } else {
                                  self.startTimeForm = moment(response.data.content.start_date_time).format("HH:mm:ss");
                                }
                              }
                            }, 200);
                        } else {
                            self.$swal('Cancelled', response.data.message, 'info');
                            self.buttonBack(2);
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            } else {
                                self.$swal('Cancelled', err.response.data.message, 'info');
                                self.buttonBack(2);
                            }
                            self.error = err.response.data.message;
                        }
                    });
                self.swipViews = 2;
            },
            loadEventDetails() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: self.detailFromEmailId,
                    }
                };
                HTTP.get("getsocialentry", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.config.defaultDate = moment(response.data.content.start_date_time).format("YYYY-MM-DD");
                                self.$refs.calendar.fireMethod('gotoDate', self.config.defaultDate);
                                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                                self.loadCalendarEvents();
                            } else {
                                self.$swal('Cancelled', response.data.message, 'info');
                                self.buttonBack(2);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                } else {
                                    self.$swal('Cancelled', err.response.data.message, 'info');
                                    self.buttonBack(2);
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            buttonBack(viewID) {
                //alert(viewID)
                self.swipViews = 0;
                self.scrollToTop();
                self.charLimit = 700;
                this.$refs.dropzone.setOption('maxFiles', 6);
                  self.filesCountError =  'Max file you can upload 6';
                if (viewID == 2) {
                    var userJson = [];
                    var userObj = localStorage.getItem("user_obj");
                    if (userObj != null) {
                        userJson = JSON.parse(userObj);
                    } else {
                        self.$router.push("/login");
                    }
                    self.editEventID = 0;
                    // self.removeAllFiles();
                    self.title = '';
                    // self.companies = '';
                    // self.companySocialMedia = '';
                    self.description = '';
                    self.hashTag = '';
                    self.startDateForm = new Date().toLocaleString();
                    console.log("back btn =", self.startDateForm);
                    self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
                    self.contactEmail = userJson.email;
                    self.contactNumber = userJson.phone;
                    self.userArr = [];
                    self.imagesPaths = [];
                    self.imagesSize = [];
                    self.imagesType = [];
                    self.charLimit = 700;
                    self.charCount();
                    self.loadCalendarEvents();
                }
            },
            deleteEvents: function (id) {
                var eventArr = [];
                eventArr.push(id);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        deleteArr: eventArr,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deleteSocialEvents", config)
                                .then(function (response) {
                                    self.buttonBack(2);
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        } else {
                                            self.$swal('Cancelled', err.response.data.message, 'info');
                                            self.buttonBack(2);
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record still intact', 'info')
                    }
                })
            },
            scrollToTop() {
                $('#scroll').click();
                /*$("html, body").animate({
                 scrollTop: 0
                 }, 600);
                 return true;*/
            },
            /*FORM CODE END*/
            previousMonth() {
                self.$refs.calendar.fireMethod('prev');
                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                self.loadCalendarEvents();
            },
            nextMonth() {
                self.$refs.calendar.fireMethod('next');
                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                self.loadCalendarEvents();
            },
            openGallery: function (documents, index) {
                var self = this;
                var arr = [];
                var new_index = 0;
                $.each(documents, function (i) {
                    if (documents[i].type.toLowerCase() == 'image') {
                        if (i == index) {
                            index = new_index;
                        }
                        arr.push(documents[i].url);
                        new_index = new_index + 1;
                    }
                });
                self.loadImagesInLightBox(arr, index);
            },
            loadImagesInLightBox: function (arr, index) {
                self.lightboxImages = arr;
                self.index = index;
                self.viewImage = self.lightboxImages[self.index];
                $('#openModel').click();
            },
            changeImage: function (move) {
                var self = this;
                if (move == 'next') {
                    self.index = self.index + 1;
                    if (self.lightboxImages.length <= self.index) {
                        self.index = 0;
                    }
                } else {
                    self.index = self.index - 1;
                    if (self.index < 0) {
                        self.index = (self.lightboxImages.length - 1);
                    }
                }
                self.viewImage = self.lightboxImages[self.index];
            },
            downloadImage: function (filepath) {
                window.open(filepath, 'Download');
                //window.location.assign(self.viewImage);
                /*location.href = self.viewImage;*/
            },
            loadEvent(id) {
                $.each(self.eventList, function (i) {
                    if (self.eventList[i].id == id) {
                        self.selected = self.eventList[i];
                    }
                });
                self.showDetails();
            },
            searchEvent() {
                if (self.searchEvents.length >= 1) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {search: self.searchEvents}
                    };
                    HTTP.get("getsocialmediacalendar", config)
                            .then(function (response) {
                                self.eventList = response.data.content;
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                }
                            });
                }
            },
            refreshEvents() {
                var refresh = true;
                if (refresh) {
                    self.loadCalendarEvents();
                }
            },
            showDetails() {
                self.swipViews = 1;
                self.scrollToTop();
            },
            showModel() {
                //console.log(self.selected.id);
                $('#openModel').click();
            },
            eventSelected(event) {
                self.selected = event;
            },
            dayClick(date, jsEvent, view) {
                /*console.log(date);
                 console.log(jsEvent);
                 console.log(view);*/
            },
            loadCalendarEvents() {
                self.selected = {};
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        start_date: self.startDate,
                        end_date: self.endDate,
                        id: self.detailFromEmailId,
                    }
                };
                HTTP.get("getsocialmediacalendar", config)
                        .then(function (response) {
                            self.events = response.data.content;
                            self.$refs.calendar.$emit('refetch-events');
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            downloadAllAttachments(id) {
                /*console.log(id);*/
                $("#DownloadAll").prop("disabled", true);
                $("#DownloadAll").html("Preparing File...");
                if (id) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {id: id}
                    };
                    HTTP.get("downloadattachment", config)
                            .then(function (response) {
                                /*console.log(id);*/
                                self.downloadImage(response.data.content.zip_file);
                                $("#DownloadAll").prop("disabled", false);
                                $("#DownloadAll").html("Download All");
                            })
                            .catch(function (err) {
                                $("#DownloadAll").prop("disabled", false);
                                $("#DownloadAll").html("Download All");
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    } else {
                                        self.$swal('Cancelled', err.response.data.message, 'info');
                                        self.buttonBack(2);
                                    }
                                }
                            });
                }
            },
            checkEventForApproval: function (id, flag) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        event_id : id,
                        flag: flag
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes '+ flag +' it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.get("modifyEventApproval", config)
                                .then(function (response) {
                                    self.buttonBack(2);
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        } else {
                                            self.$swal('Cancelled', err.response.data.message, 'info');
                                            self.buttonBack(2);
                                        }
                                    }
                                });
                        if(flag == 'approve') {
                            self.$swal(self.capitalizeFirstLetter(flag), 'You successfully approved the record(s).', 'success')
                        } else if(flag =="deny") {
                            self.$swal(self.capitalizeFirstLetter(flag), 'You successfully denied the record(s).', 'success')
                        }
                    } else {
                        self.$swal('Cancelled', 'Your record still intact', 'info')
                    }
                })
            },
        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.textOverFlow {
      display: block;
    text-overflow: ellipsis;
    word-wrap: break-word;
    overflow: auto;
    line-height: 1.8em;
}

/* .multiselect__content-wrapper{z-index: 10001;} */
#socialMediaForm .multiselect--active{z-index:10001}

.social-media-calendar-container .bottom-employee-detail-left {
    margin-bottom: 0px !important;
}

.internal-page-main-section {
    float: left;
    padding-top: 6em !important;
    padding-bottom: 6em;
    position: relative;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/SocialMediaCalendar.vue